import { ReactNode } from "react";
import { QueryParamProvider as CoreQueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

export function QueryParamProvider({ children }: { children: ReactNode }) {
  return (
    <CoreQueryParamProvider adapter={ReactRouter6Adapter}>
      {children}
    </CoreQueryParamProvider>
  );
}
